<template>
  <div>
    <base-header class="pb-6" type="pink">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Principal</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row >
        <b-col lg="6" cols="12" >
          
          <!-- Account Status Card -->
          <card v-if="user.cHasVideoAccess !== null" class="border-0">
            <div class="d-flex align-items-center">
              <div class="mr-auto">
                <h5 class="card-title text-uppercase text-muted mb-0">Estatus de cuenta</h5>
                <span v-if="user.cHasVideoAccess" class="h2 font-weight-bold mb-0">Activa</span>
                <span v-if="!user.cHasVideoAccess && user.deferredDaysOfAccess.length === 0" class="h2 font-weight-bold mb-0">Limitada</span>
                <span v-if="!user.cHasVideoAccess && user.deferredDaysOfAccess.length > 0" class="h2 font-weight-bold mb-0">Pagada</span>
              </div>
              <div v-if="!user.cHasVideoAccess && user.deferredDaysOfAccess.length === 0" class="mr-2">
                <b-link class="btn btn-warning btn-sm" :to="{ name: 'Checkout' }">
                  <span class="btn-inner--text">Ir al pago</span>
                </b-link> 
              </div>
              <div>
                <div v-if="user.cHasVideoAccess" class="icon icon-shape bg-success text-dark rounded-circle shadow">
                  <i class="fas fa-check text-white"></i>
                </div>
                <div v-if="!user.cHasVideoAccess" class="icon icon-shape bg-yellow text-dark rounded-circle shadow">
                  <i class="fas fa-pause text-white"></i>
                </div>
              </div>
            </div>
            <div v-if="!user.cHasVideoAccess && user.deferredDaysOfAccess.length > 0" class="mt-2 mb-0 pb-0">
              <span><small class="text-muted d-block my-0">Tu acceso se activará en la fecha de comienzo de tu plan.</small></span>
            </div>
          </card>


          <!-- Placeholder Card -->
          <card v-if="user.cHasVideoAccess === null" class="border-0">
            <div class="d-flex flex-column text-center text-muted">
              <div><i class="fas fa-spinner fa-spin display-1"></i></div>
            </div>
          </card>

        </b-col>
        <b-col lg="6" cols="12">

          <!-- Video Access Card -->
          <card v-if="user.userType === 'user' && user.cHasVideoAccess" class="border-0">
            <div class="d-flex">
              <div>
                <h5 class="card-title text-uppercase text-muted mb-0">Acceso hasta:</h5>
                <span class="h2 font-weight-bold mb-0">{{ user.accessUntil }}</span>
              </div>
              <div class="ml-auto">
                <div class="icon icon-shape bg-gradient-info text-dark rounded-circle shadow">
                  <i class="fas fa-key text-white"></i>
                </div>
              </div>
            </div>
            <div v-if="user.deferredDaysOfAccess.length > 0" class="mt-2 mb-0 pb-0">
              <span><small class="text-muted d-block my-0">Los días del plan que pagaste por adelantado se reflejarán en la fecha de comienzo de dicho plan.</small></span>
            </div>
          </card>

        </b-col>

      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row class="starter-page">
        <b-col cols="12">
          
          <!-- Dashboard Videos -->
          <card v-if="user.cHasVideoAccess !== null" class="no-border-card" body-classes="px-0 pb-1">
            <template slot="header">
              <h3 v-if="user.cHasVideoAccess" class="mb-0">Últimas clases</h3>
              <h3 v-else class="mb-0">Clases de prueba</h3>
            </template>

            <!-- Videos Grid -->
            <div v-if="videosFetched.status">
              <videos-grid :videos="videos"></videos-grid>
            </div>

            <div v-if="!videosFetched.status" class="d-flex justify-content-center py-8">
              <div class="d-flex flex-column text-center text-muted">
                <div><i class="fas fa-spinner fa-spin display-1"></i></div>
                <div>Cargando</div>
              </div>
            </div>
          </card>

          <!-- Dashboard Documents -->
          <card v-if="user.cHasVideoAccess !== null" class="no-border-card" body-classes="px-0 pb-1">
            <template slot="header">
              <h3 v-if="user.cHasVideoAccess" class="mb-0">Últimos documentos</h3>
              <h3 v-else class="mb-0">Documentos de prueba</h3>
            </template>

            <!-- Documents Grid -->
            <div v-if="documentsFetched.status">
              <documents-grid :documents="documents"></documents-grid>
            </div>

            <div v-if="!documentsFetched.status" class="d-flex justify-content-center py-8">
              <div class="d-flex flex-column text-center text-muted">
                <div><i class="fas fa-spinner fa-spin display-1"></i></div>
                <div>Cargando</div>
              </div>
            </div>
          </card>

          <!-- Placeholder Content Card -->
          <card v-if="user.cHasVideoAccess === null" class="no-border-card" body-classes="px-0 pb-1">
            <div class="d-flex flex-column text-center text-muted py-6">
              <div><i class="fas fa-spinner fa-spin display-1"></i></div>
              <div>Cargando</div>
            </div>
          </card>

        </b-col>

        <!-- Notifications -->
        <!-- <b-col lg="4">
          <timeline-card></timeline-card>
        </b-col> -->
        
      </b-row>
    </b-container>
  </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import TimelineCard from './Components/TimelineCard.vue';
import VideosGrid from './Components/VideosGrid.vue'
import DocumentsGrid from './Components/DocumentsGrid.vue'
import { videoStorage } from '@/store/videos.js'
import { documentStorage } from '@/store/documents.js'
import { mainStorage } from '@/store/main.js'

export default {
  name: 'starter-page',
  components: {
    RouteBreadCrumb,
    TimelineCard,
    VideosGrid,
    DocumentsGrid
  },
  data() {
    return {
      user: mainStorage.state.user,
      videos: videoStorage.state.dashboardVideos,
      videosFetched: videoStorage.state.dashboardVideosFetched,
      documents: documentStorage.state.dashboardDocuments,
      documentsFetched: documentStorage.state.dashboardDocumentsFetched
    };
  },
  watch: {
    'user.cHasVideoAccess' (to, from) {
      videoStorage.resetFetchedStatus()
      videoStorage.fetchDashboardVideos(to)
      documentStorage.resetFetchedStatus()
      documentStorage.fetchDashboardDocuments(to)
    }
  },
  mounted() {
    if (this.user.cHasVideoAccess !== null) {
      videoStorage.fetchDashboardVideos(this.user.cHasVideoAccess)
      documentStorage.fetchDashboardDocuments(this.user.cHasVideoAccess)
    }
  }
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
